import { render, staticRenderFns } from "./auto-message-add-crm-email-campaign.vue?vue&type=template&id=a91bfea4&scoped=true&"
import script from "./auto-message-add-crm-email-campaign.vue?vue&type=script&lang=js&"
export * from "./auto-message-add-crm-email-campaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a91bfea4",
  null
  
)

export default component.exports